const Contact = ({ className }: { className?: string }) => {
  return (
    <svg
      width="67"
      height="63"
      viewBox="0 0 67 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.2977 52.0866L0 63V0H67V52.0866H13.2977Z" fill="#FB2576" />
    </svg>
  );
};

export default Contact;
